export enum SignupSteps {
    SELECT_SIGNUP_TYPE,
    EMAIL_VERIFICATION,
    CHECK_EMAIL,
    SEARCH_COMMUNITY,
    ADD_SIGNUP_DETAILS,
    JOIN_COMPLETE,
}
